import * as Yup from 'yup';

import { PasswordSchema } from '@utils/form-validation/common-schemas';

export const LoginFormSchema = Yup.object().shape({
  email: Yup.string()
    .email('Lütfen geçerli bir e-posta giriniz.')
    .max(255)
    .required('E-posta alanı boş bırakılamaz.'),
  password: Yup.string().nullable().required('Şifre alanı boş bırakılamaz.'),
});

export const SeturFormSchema = Yup.object().shape({
  seturEmail: Yup.string()
    .email('Lütfen geçerli bir e-posta giriniz.')
    .max(255)
    .required('E-posta alanı boş bırakılamaz.'),
});

export const LoyaltyLoginFormSchema = Yup.object().shape({
  name: Yup.string().nullable().required('Ad alanı boş bırakılamaz.'),
  surname: Yup.string().nullable().required('Soyad alanı boş bırakılamaz.'),
  refNo: Yup.string()
    .nullable()
    .max(11, 'Referans numarası en fazla 11 karakter içermektedir.'),
  birthDay: Yup.string(),
  loyaltyConsent: Yup.bool()
    .required('Setur Extra Üyelik Sözleşmesi onaylanmalıdır.')
    .oneOf([true], 'Setur Extra Üyelik sözleşmesi onaylanmalıdır.'),
});

export const LoyaltyValidationFormSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .min(13, 'Telefon Numarası Girmeniz Gereklidir.')
    .required('Telefon Numarası Girmeniz Gereklidir.'),
});
export const RegisterFormSchema = PasswordSchema.shape({
  name: Yup.string().nullable().required('Ad alanı boş bırakılamaz.'),
  surname: Yup.string().nullable().required('Soyad alanı boş bırakılamaz.'),
  email: Yup.string()
    .email({
      empty: 'E-posta alanı boş bırakılamaz.',
      invalid: 'Lütfen geçerli bir e-posta adresi giriniz',
    })
    .max(255),
  phoneNumber: Yup.string()
    .min(13, 'Telefon Numarası Girmeniz Gereklidir.')
    .required('Telefon Numarası Girmeniz Gereklidir.'),
  ...{
    agreement: Yup.bool().oneOf(
      [true],
      'İnternet üyelik sözleşmesini okuyup, onaylamalısınız.'
    ),
  },
  kvkk: Yup.object({
    isConsentTextConfirmed: Yup.bool().oneOf(
      [true],
      'SMS, Telefon veya E-posta iletişim araçlarından birisi seçilmelidir.'
    ),
    isEmailConfirmed: Yup.bool().default(false),
    isPhoneConfirmed: Yup.bool().default(false),
    isSMSConfirmed: Yup.bool().default(false),
  }),
});

export const PasswordResetFormModalSchema = Yup.object().shape({
  email: Yup.string()
    .email('Lütfen geçerli bir e-posta giriniz.')
    .max(255)
    .required('E-posta alanı boş bırakılamaz.'),
});
